<div *ngIf="model">
    <div style="display: flex;justify-content: end; padding: 10px;">
        
        <button (click)="importFile.click();" style="margin-right: 10px;">{{'general.add' | translate}} <span style="float:right;font-weight: bold;margin-left:10px">{{ ((this.AttachmentsSize)/1000000).toFixed(2)}}/5 MB</span></button>
    </div>
    <div *ngIf="model.FatturaElettronicaBody.DatiPagamento">
        <table class="table">
            <thead>
                <tr>
                    <th class="col-3">{{'invoices.edit.attachments.other.name' | translate}}</th>
                    <th class="col-3">{{'invoices.edit.attachments.other.algorithm' | translate}}</th>
                    <th class="col-2">{{'invoices.edit.attachments.other.format' | translate}}</th>
                    <th class="col-3">{{'invoices.edit.attachments.other.description' | translate}}</th>
                    <th class="col-1"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let val of model.FatturaElettronicaBody.Allegati; let i = index;">
                    <td>
                        <input type="text" class="form-control" [placeholder]="'invoices.edit.attachments.other.name' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.NomeAttachment" (ngModelChange)="notifyChange()">
                    </td>
                    <td>
                        <input type="text" maxlength="10" class="form-control" [placeholder]="'invoices.edit.attachments.other.algorithm' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.AlgoritmoCompressione" (ngModelChange)="notifyChange()">
                    </td>
                    <td>
                        <input type="text" maxlength="10" class="form-control" [placeholder]="'invoices.edit.attachments.other.format' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.FormatoAttachment" (ngModelChange)="notifyChange()">
                    </td>
                    <td>
                        <input type="text" class="form-control" [placeholder]="'invoices.edit.attachments.other.description' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.DescrizioneAttachment" (ngModelChange)="notifyChange()">
                    </td>
                    <td>
                        <button type="button" class="btn btn-danger" (click)="deleteAllegato(i); notifyChange();"><img src="assets/icone_varie/cestino.svg"></button>
                    </td>
                </tr>
            </tbody>    
        </table>
    </div>
    <input type="file" name="my_file" #importFile style="visibility: hidden;" (change)="addAllegato($event);">
</div>
